import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Stakeholders by Validation Status',
      type: 'charts',
      alias: 'stakeholders-by-validation-status',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Validation Status',
                  slices: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Not Started',
                          color: '#D9DEE7',
                          value: {
                            '#': {
                              '@': 'notStartedStakeholders',
                            },
                          },
                          onClick: {
                            '{}': {
                              action: {
                                '{}': {
                                  payload: {
                                    '{}': {
                                      goto: {
                                        '{}': {
                                          variables: {
                                            '{}': {
                                              validationStatus: 'Not Started',
                                            },
                                          },
                                          navigationId: 'stakeholder.log',
                                        },
                                      },
                                    },
                                  },
                                  operation: 'ui.navigate',
                                },
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'In Progress',
                          color: '#729BD1',
                          value: {
                            '#': {
                              '@': 'inProgressStakeholders',
                            },
                          },
                          onClick: {
                            '{}': {
                              action: {
                                '{}': {
                                  payload: {
                                    '{}': {
                                      goto: {
                                        '{}': {
                                          variables: {
                                            '{}': {
                                              validationStatus: 'In Progress',
                                            },
                                          },
                                          navigationId: 'stakeholder.log',
                                        },
                                      },
                                    },
                                  },
                                  operation: 'ui.navigate',
                                },
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Completed',
                          color: '#183B70',
                          value: {
                            '#': {
                              '@': 'completedStakeholders',
                            },
                          },
                          onClick: {
                            '{}': {
                              action: {
                                '{}': {
                                  payload: {
                                    '{}': {
                                      goto: {
                                        '{}': {
                                          variables: {
                                            '{}': {
                                              validationStatus: 'Completed',
                                            },
                                          },
                                          navigationId: 'stakeholder.log',
                                        },
                                      },
                                    },
                                  },
                                  operation: 'ui.navigate',
                                },
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                  description: 'Stakeholder count by validation status.',
                },
              },
            ],
          },
          type: 'donut',
        },
      },
    },
  },
  subqueries: {
    completedStakeholders: {
      filter: {
        '=': [
          {
            '@.': '!validation_status',
          },
          'Completed',
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      selection: {
        '@.': '!id',
      },
    },
    inProgressStakeholders: {
      filter: {
        '=': [
          {
            '@.': '!validation_status',
          },
          'In Progress',
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      selection: {
        '@.': '!id',
      },
    },
    notStartedStakeholders: {
      filter: {
        '=': [
          {
            '@.': '!validation_status',
          },
          'Not Started',
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      selection: {
        '@.': '!id',
      },
    },
  },
}
